import { useState, useEffect } from 'react';
import { SubmitFunction, Location } from 'react-router';
import useIsClient from '@/util-react-router/hooks/use-is-client';
import {
  init as FullStoryInit,
  isInitialized as FullStoryIsInitialized,
  FullStory,
} from '@fullstory/browser';
import { useFullstorySession } from './use-fullstory-session';

interface FullstorySetupProps {
  user_signed_in: boolean;
  account_id?: string;
  FULLSTORY_ORG_ID?: string;
  submit: SubmitFunction;
  location: Location;
}

export function useFullstorySetup({
  user_signed_in,
  account_id,
  FULLSTORY_ORG_ID,
  submit,
  location,
}: FullstorySetupProps) {
  const [shouldInitializeFullstory, setShouldInitializeFullstory] = useState(true);
  const [fullstoryRecordingStarted, setFullstoryRecordingStarted] = useState(false);

  useEffect(() => {
    if (FULLSTORY_ORG_ID && shouldInitializeFullstory) {
      FullStoryInit({ orgId: FULLSTORY_ORG_ID });
      setShouldInitializeFullstory(false);
    }
  }, [FULLSTORY_ORG_ID, shouldInitializeFullstory]);

  const fullstoryInitializationComplete = useIsClient() && FullStoryIsInitialized();

  // This is a FullStory listener that will notify when session recording starts. (initialized != recording)
  useEffect(() => {
    if (fullstoryInitializationComplete) {
      FullStory('observe', {
        type: 'start',
        callback: async () => {
          setFullstoryRecordingStarted(true);
        },
      });
    }
  }, [fullstoryInitializationComplete, setFullstoryRecordingStarted]);

  //Once initialized, we can use the useFullstorySession hook to send session data to the BE.
  useFullstorySession({
    fullstoryRecordingStarted,
    user_signed_in,
    account_id,
    submit,
    location,
  });
}
